import { HomeOutlined } from '@ant-design/icons';
import { createSelector } from '@reduxjs/toolkit';
import { reduxEqualityFunction } from 'library/helpers/utility';
import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { peopleActions } from 'reduxStore/people/slice';
import { Col, Flex, Row, Typography } from 'zui/Antd';
import ViewMoreToggle from '../ViewMoreToggle';

const { Text } = Typography;

// Selector to get person by ID
const selectPersonByID = createSelector(
	[(state) => state.People.data, (_, personID) => personID],
	(people, personID) => people.find((person) => person.personID === personID) || {}
);

const PeopleAddressPanel = ({ personID }) => {
	const dispatch = useDispatch();

	// Selector to get person by ID
	const person = useSelector((state) => selectPersonByID(state, personID), {
		equalityFn: reduxEqualityFunction
	});

	//local states
	const [showAll, setShowAll] = useState(false);
	const maxItemsToShow = 4;

	// Load bookings data on component mount
	useEffect(() => {
		dispatch(peopleActions.loadPeopleAddress({ personID }));
	}, [personID, dispatch]);

	// Determine the number of addresses to display based on showAll state
	const visibleAddresses = showAll ? person.address?.data : person.address?.data.slice(0, maxItemsToShow);

	return (
		<Fragment>
			{/* // If no address data is available, return null */}
			{visibleAddresses?.data === 0 && <Text type='secondary'>No addresses available.</Text>}

			<Row gutter={[16, 16]}>
				{visibleAddresses &&
					visibleAddresses.length > 0 &&
					visibleAddresses.map((address) => (
						<Col span={24} key={address.addressID}>
							<Flex align='center' justify='start' gap={16}>
								<HomeOutlined style={{ fontSize: '24px' }} />
								<Flex vertical>
									<Text type='secondary'>Address</Text>
									<Text strong>{address.fullAddress}</Text>
								</Flex>
							</Flex>
						</Col>
					))}
			</Row>

			{/* View More / View Less toggle */}
			{person?.address?.data?.length > maxItemsToShow && (
				<ViewMoreToggle
					data={person.address?.data}
					maxItemsToShow={maxItemsToShow}
					onToggle={(showAll) => setShowAll(showAll)}
				/>
			)}
		</Fragment>
	);
};

export default PeopleAddressPanel;
